var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('nav-bar'),_c('web-main'),_c('footer-layout'),_c('right-side')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }